module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "logo",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "blurb"
  }, [_vm._v("This edition of "), _c('em', [_vm._v("The Physiology of Taste")]), _vm._v(" by Jean A. Brillat-Savarin  was reproduced by permission from the volume in the collection of the American Antiquarian Society (AAS), Worcester, Massachusetts. Founded in 1812 by Isaiah Thomas, a Revolutionary War patriot and successful printer and publisher, the Society is a research library documenting the life of Americans from the colonial era through 1876. AAS aims to collect, preserve, and make available as complete a record as possible of the printed materials from the early American experience. The cookbook collection includes approximately 1,100 volumes.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-039eb26d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/blurb.vue
// module id = 57
// module chunks = 0